<template>
  <div class="dlblock">
    <div class="img-view" v-if="imgUrl">
      <img :src="imgUrl" class="avatar">
      <div class="big-show">
        <div class="big-show-box">
          <i @click.stop="modal = true" class="el-icon-zoom-in avatar-upload-icon"></i>
        </div>
      </div>
    </div>
    <div v-else class="img-box">
      无照片
    </div>
    <el-dialog :modal="false" :visible.sync="modal" width="60%">
      <img width="100%" :src="imgUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        modal: false
      }
    },
    computed: {
      imgUrl () {
        return this.value
      }
    }
  }
</script>

<style scoped>
  .img-box {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    width: 148px;
    height: 148px;
    display: inline-block;
    position: relative;
    overflow: hidden;
    text-align: center;
    line-height: 148px;
  }

  .avatar {
    width: 148px;
    height: 148px;
    display: block;
  }

  .avatar-upload-icon {
    font-size: 28px;
    color: #8c939d;
    text-align: center;
    cursor: pointer;
  }

  .img-view {
    position: relative;
    display: inline-block;
  }

  .img-view:hover .big-show {
    display: block;
    background: rgba(0, 0, 0, 0.5);
  }

  .img-view:hover .avatar-upload-icon {
    color: #fff;
  }

  .big-show {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .big-show-box {
    text-align: center;
    margin-top: 60px;
  }
</style>
